import axiosAuth from '../../axiosPublic';

async function index() {
  let response = await axiosAuth.get('/public/company');
  return response.data;
}

export default {
  index,
};
